import {ElementRef, Injectable, ViewChild} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InterfaceService } from "@app/interfaces";
import {BehaviorSubject} from "rxjs";
import {BsModalRef} from "ngx-bootstrap";
import {SidepanelModalService} from "@app/sidepanel/services/sidepanel-modal.service";
import {DomSanitizer} from "@angular/platform-browser";
import {AddOpportunityService} from "@app/features/customers/add-opportunity/service/add-opportunity.service";
import {AuthService} from "@app/core";
import {
    OpportunityTemplateService
} from "@app/features/system-settings/opportunity-template/services/opportunity-template.services";

@Injectable({
    providedIn: 'root'
})

export class createHtmlToPdfService extends InterfaceService {
    private sendtoCustomerLoading: boolean;
    private opportunityId: number;
    private opportunityProposalId: number;
    private proposalPages: any;
    private PricingSectionAdvanceStyles: any;
    private pricingSummaryAdvanceStyles: any;
    private hasSMSModuleAccess: any;
    private pricingSectionDetails: any;
    private pdfDatamake: any = {
        htmldata: [],
        style: [],
        countryName: '',
        googleFontLink: [],
        pdfVersion: '',
        opportunitiesProposalID: '',
        proposalStatus: '',
        opportunityId:'',
    };
    private bodyHtmlContent : any;
    private proposalVersion: number;
    private proposalSendStatus: string;
    private proposalPdfDetails: any;
    private PdfFilesData: any;
    private Url: any;
    private url: any;
    @ViewChild('iframe') iframe!: ElementRef;
    private frameValue: HTMLDivElement;
    normalTableStyles: any = [];
    private proposalValueMismatch: boolean;
    private proposalValueMismatchError: boolean;
    private sendButtonDisabled: boolean;
    private pagesDataList: any = [];
    defectEnabled: boolean = false;

    constructor(
        public bsModalRef: BsModalRef,
        private sanitizer: DomSanitizer,
        private opportunityService: AddOpportunityService,
        private authService: AuthService,

    ) {
        super();
    }
    opportunitiesPages(opportunityId,proposalId,body) {
        this.sendtoCustomerLoading = true;
        this.opportunityProposalId = proposalId;
        this.opportunityId = opportunityId;
        this.opportunityService.getOpportunityPages(opportunityId, proposalId, true).subscribe(responseData => {
            if (responseData) {
                this.proposalPages = responseData['opportunityPages'];
                this.PricingSectionAdvanceStyles = responseData['styles']
                this.pricingSummaryAdvanceStyles = responseData['summaryStyles'];
                this.hasSMSModuleAccess = responseData['hasSMSAccess'];
                this.pricingSectionDetails = responseData['pricingSection']
                this.proposalVersion = responseData['currentProposalVersion'];
                /* for (let i = 0; i < this.pricingSummaryAdvanceStyles.length; i++) {
                     this.pricingSummaryAdvanceStyles[i] = JSON.parse(this.pricingSummaryAdvanceStyles[i]['value']);
                 }*/

                const collectionOfPages = this.proposalPages.flatMap(arr => {
                    if (arr.hasOwnProperty('pages')) {
                        arr.pages.forEach(page => page['option'] = arr['optionName']);
                        return arr.pages
                    } else {
                        return []
                    }
                });
                this.proposalVersion = responseData['currentProposalVersion'];
                this.proposalPages = collectionOfPages;
                /*this.proposalPages.forEach((page, index) => {
                    this.pricingSectionDetails.forEach((ps) => {
                        const pricingSectionNameId = `pricingSectionName_${ps.sectionId}`;
                        if(page.value.includes(pricingSectionNameId)) {
                            const htmlElement = document.createElement('div');
                            htmlElement.innerHTML = page.value.trim();
                            const psJquery = $(htmlElement).find(`#${pricingSectionNameId}`)
                            if(psJquery && psJquery[0]) {
                                const regex2 = /^Pricing section {2}\d+$/;
                                const regex = /^Pricing section \d+$/;
                                if(regex.test(psJquery[0]['innerText'] || regex2.test(psJquery[0]['innerText']) {
                                    psJquery.html('');
                                    page.value = htmlElement.innerHTML;
                                }
                            }
                        }
                    });
                });*/
                this.loadFrame(body);
            }
        });

    }


    loadFrame(body) {
        this.bodyHtmlContent = body;
        this.pdfDatamake.pdfVersion = this.proposalVersion;
        this.pdfDatamake.proposalStatus = this.proposalSendStatus;
        if (this.pdfDatamake.proposalStatus == 'sent' && this.proposalPdfDetails) {
            this.PdfFilesData = this.proposalPdfDetails;
            this.Url = this.proposalPdfDetails['url'];
        }

        if (body) {
            let attrStyles = this.getAllOtherStyles();
            for (let i = 0; i < attrStyles.length; i++) {
                this.normalTableStyles.push(attrStyles[i])
            }
            this.checkingPricingSectionsTotalGrants(body)
            this.findEmptyPages(body);
            // this.findReplaceIframeVideoElement(body);
            // this.updateStylesToDocument(this.normalTableStyles, 'normalTable')
            // this.updateStylesToDocument(this.PricingSectionAdvanceStyles, 'pricingSection');
            // this.updateStylesToDocument(this.pricingSummaryAdvanceStyles, 'pricingSummary');
            this.getCsPageList();

        }
    }

    getAllOtherStyles() {
        let styles = [];
        let block = $(this.bodyHtmlContent).contents().find('.fr-element.froala-table.normal-table-width').find('table');
        if ($(block).length > 0) {
            $(block).each(function (i, value) {
                let x = $(value).attr('data-styling');
                if (x) {
                    let y = JSON.parse(x).advancedStyle;
                    y.isNormalTable = true;
                    styles.push(y);
                }
            });
        }
        return styles;
    }

    checkingPricingSectionsTotalGrants(body) {
        if (!this.pricingSectionDetails.length) return;
        for (let i = 0; i < this.pricingSectionDetails.length; i++) {
            let items = this.pricingSectionDetails[i];
            let sectionId = items['sectionId'];
            let grandTotal = items['grandTotal'];
            if (!sectionId || grandTotal === undefined) return;
            let findTable = body.querySelector(`#cs_dynamic_styling_${sectionId}`);
            if (!findTable) return;
            const grandTotalElem = findTable.querySelector(`#grand_total_${sectionId}`);
            if (!grandTotalElem){
                this.proposalValueMismatch = true;
                this.proposalValueMismatchError = true;
                break;
            }
            const getValue = grandTotalElem.textContent.trim();
            if (getValue !== grandTotal) {
                this.proposalValueMismatch = true;
                this.proposalValueMismatchError = true;
                this.sendButtonDisabled = true;
                break;
            } else {
                this.proposalValueMismatch = false;
                this.proposalValueMismatchError = false;
            }
        }
    }

    findEmptyPages(body: any) {

        const child = body.querySelectorAll('.cs_page')

        child.forEach((page: HTMLElement) => {
            if (!page) {
                return;
            }

            if($(page).find('.acceptance-margin') && $(page).find('.acceptance-margin').length && $(page).find('.acceptance-margin').hasClass('acceptance-margin')){
                return;
            }
            $(page).find('.block-selected').removeClass('block-selected');
            $(page).find('#block-type-helper').remove(); //TODO  for older template
            $(page).find('.block-type-helper').remove(); //TODO for new template
            const titleElements = page.querySelectorAll('[tag="Title"]');
            const textareaElements = page.querySelectorAll('[tag="Textarea"]');
            const imageElements = page.querySelectorAll('[tag="Image"]');
            const videoElements = page.querySelectorAll('[tag="Video"]');
            const tableElements = page.querySelectorAll('[tag="Table"]');
            const pricingsectionElements = page.querySelectorAll('[tag="pricingsection"]');
            const addonElements = page.querySelectorAll('[tag="Addon"]');
            const optionspricingbreakupElements = page.querySelectorAll('[tag="Summary"]');
            const defectElements = page.querySelectorAll('[tag="Defect"]');

            function hasNonEmptyTextContent(element) {
                return element.textContent.trim() !== '';
            }

            function processTableElement(elem) {
                const tdElements = elem.querySelectorAll('td');
                const hasText = Array.from(tdElements).some(hasNonEmptyTextContent);
                if (!hasText) {
                    $(elem).addClass('editorHideShowElement');
                }
            }

            titleElements.forEach(elem => {
                if (!hasNonEmptyTextContent(elem)) {
                    $(elem).addClass('editorHideShowElement');
                }
            });

            textareaElements.forEach(elem => {
                if (!hasNonEmptyTextContent(elem)) {
                    $(elem).addClass('editorHideShowElement');
                }
            });

            imageElements.forEach(elem => {
                if ($(elem).find('.img-btn').length) {
                    $(elem).addClass('editorHideShowElement');
                }
            });

            videoElements.forEach(elem => {
                if ($(elem).find('.img-btn').length) {
                    $(elem).addClass('editorHideShowElement');
                }
            });

            tableElements.forEach(processTableElement);

            //pricing section table
            if (pricingsectionElements && pricingsectionElements.length) {
                for (let i = 0; i < pricingsectionElements.length; i++) {
                    let getTableElement;
                    if ($(pricingsectionElements[i]).attr('tag-name') === 'Defects'){
                        let emptyPricing =  $(pricingsectionElements[i]).find('#defect-summary-section').find("[id^='grand_total_']").text();
                        if (emptyPricing && emptyPricing == '0.00'){
                            $(pricingsectionElements[i]).closest('.row-item').addClass('editorHideShowElementDefectValueZero');
                        }
                    }else{
                        getTableElement = $(pricingsectionElements[i]).find('table');
                        if (getTableElement && getTableElement.length) {
                            let getPricingTable = $(pricingsectionElements[i]).find('tbody tr td');
                            if (getPricingTable && getPricingTable[0].innerHTML == '') {
                                $(getPricingTable).closest('.row-item').addClass('editorHideShowElement')
                            }
                        }
                    }
                }
            }
            //pricing section table addons
            if (addonElements && addonElements.length) {
                for (let i = 0; i < addonElements.length; i++) {
                    let getTableElement = $(addonElements[i]).find('table');
                    if (getTableElement && getTableElement.length) {
                        let getPricingTable = $(addonElements[i]).find('tbody tr td');
                        if (getPricingTable && getPricingTable[0].innerHTML == '') {
                            $(getPricingTable).closest('.cs_block_s').addClass('editorHideShowElement')
                        }
                    }
                }
            }
            if (optionspricingbreakupElements && optionspricingbreakupElements.length) {
                for (let i = 0; i < optionspricingbreakupElements.length; i++) {
                    let getTableSummary = $(optionspricingbreakupElements[i]).find('table');
                    if (getTableSummary && getTableSummary.length) {
                        let getTbody = $(getTableSummary).find('tbody tr');
                        if (getTbody && getTbody.length) {
                            let getPricingTable = $(getTbody).find('td');
                            if (getPricingTable && getPricingTable[0].innerHTML.trim() == '') {
                                $(optionspricingbreakupElements[i]).closest('.row-item').addClass('editorHideShowElement');
                            }
                        } else {
                            $(optionspricingbreakupElements[i]).closest('.row-item').addClass('editorHideShowElement');
                        }
                    }
                }
            }
            if (defectElements && defectElements.length) {
                for (let i = 0; i < defectElements.length; i++) {
                    let getDefectElement = $(defectElements[i]).find('#defect-summary-section');
                    if (getDefectElement && getDefectElement.length == 0) {
                        $(getDefectElement).closest('.cs_block_s').addClass('editorHideShowElement')
                    }
                }
            }
            const editorHideShowElements = page.querySelectorAll('.editorHideShowElement');
            const totalElementsLength = titleElements.length + textareaElements.length + imageElements.length + videoElements.length + tableElements.length + pricingsectionElements.length + addonElements.length + optionspricingbreakupElements.length + defectElements.length;
            const editorHideShowLength = editorHideShowElements.length;

            if (totalElementsLength === editorHideShowLength) {
                let eleBackImage = $(page).css('background-image');
                let checkBackgroungColour = $(page).css('background-color');
                let findBackgroundHeader = $(page).find('div[id^="headerandfooter_header_"]').css('background-image') || '';
                let findBackgroundFooter = $(page).find('div[id^="headerandfooter_footer_"]').css('background-image') || '';

                if (
                    (eleBackImage === 'none' || !eleBackImage) &&
                    (checkBackgroungColour === 'rgb(255, 255, 255)' || !checkBackgroungColour) &&
                    (findBackgroundHeader === 'none' || !findBackgroundHeader) &&
                    (findBackgroundFooter === 'none' || !findBackgroundFooter)
                ) {
                    $(page).addClass('over-all-page-hide');
                }
            }

        });

        this.findTableEmptyColumn(body);
        this.findReplaceRow(body);
        // this.checkCoverBackPageBackground(body);
    }

    findTableEmptyColumn(body: any) {
        let findTableEmptyPage = body.getElementsByClassName('notes');
        for (let index = 0; index < findTableEmptyPage.length; index++) {
            let element = findTableEmptyPage[index];
            if (element.value == '') {
                $(element).addClass("contentPage-empty-notes-row");
            }
        }
    }

    findReplaceRow(body: any) {
        const child: any = body.querySelectorAll('.cs_page')
        child.forEach((element: any) => {
            let textNode: any = $(element).find('.desc')
            if (textNode.length) {
                for (let i = 0; i < textNode.length; i++) {
                    let textValue: any = $(textNode[i]).val();
                    let tempDiv: any = `<div class="desc ignore-sorting">${textValue}</div>`
                    $(textNode[i]).replaceWith(tempDiv);
                }
            }
            let textarea: any = $(element).find('.notes')
            if (textarea.length) {
                for (let i = 0; i < textarea.length; i++) {
                    let textareaValue: any = $(textarea[i]).val();
                    let textareaValuetempDiv: any = `<div class="notes ignore-sorting">${textareaValue}</div>`
                    $(textarea[i]).replaceWith(textareaValuetempDiv);
                }
            }
            let textareaDefect: any = $(element).find('.ignore-sorting');

        });
    }

    updateStylesToDocument(stylesList: any, tableType = '') {
        let dynamicStyle = '';

        if (tableType == 'pricingSummary') {
            if (stylesList && stylesList.length) {
                for (let i = 0; i < stylesList.length; i++) {
                    dynamicStyle += ' ' + this.getStyleFromJSON(stylesList[i], tableType);
                    this.findAndremoveWidth(stylesList[i], tableType)
                }
            }
        } else if (tableType == 'normalTable') {
            if (stylesList && stylesList.length) {
                for (let i = 0; i < stylesList.length; i++) {
                    dynamicStyle += ' ' + this.getStyleFromJSON(stylesList[i], tableType);
                }
            }
        } else {
            if (stylesList && stylesList.length) {
                for (let i = 0; i < stylesList.length; i++) {
                    dynamicStyle += ' ' + this.getStyleFromJSON(stylesList[i], tableType);
                    this.findAndremoveWidth(stylesList[i], tableType)
                }
            }
        }
        this.pdfDatamake.style.push(dynamicStyle)
        if (dynamicStyle != '') {
            this.updateStylesInCSEditor(dynamicStyle, tableType);
        }
    }

    getStyleFromJSON(styleData: any, tableType = '') {
        var identifier = ''
        var totalSectionIdentifier = '';
        if (tableType == 'pricingSummary') {
            identifier = '#pricing-items-breakup-tpl_' + styleData['currentSectionId'];
            totalSectionIdentifier = '#pricing-summary_total-section_' + styleData['currentSectionId'];
        } else if (tableType == 'normalTable') {
            identifier = '#' + styleData['hashId'];
        } else {
            identifier = '#Pricing_' + styleData['sectionId'];
            totalSectionIdentifier = '#total_' + styleData['sectionId'];
        }

        let contentBlockBorderWidth = styleData['contentBlockBorderWidthIndividualSide'] ? (styleData.contentBlockBorderWidthTop + 'px ' + styleData.contentBlockBorderWidthRight + 'px ' + styleData.contentBlockBorderWidthBottom + 'px ' + styleData.contentBlockBorderWidthLeft + 'px') : (styleData['contentBlockBorderWidth'] != '' ? styleData['contentBlockBorderWidth'] + 'px' : 0);
        let contentBlockBorderColor = styleData['contentBlockBorderColor'] != 'No colour' ? styleData['contentBlockBorderColor'] : '#ccc';
        let contentBlockBorderRadius = styleData['contentBlockBorderRadiusIndividualSide'] ? (styleData['contentBlockBorderRadiusTopLeft'] + 'px ' + styleData['contentBlockBorderRadiusTopRight'] + 'px ' + styleData['contentBlockBorderRadiusBottomRight'] + 'px ' + styleData['contentBlockBorderRadiusBottomLeft'] + 'px') : (styleData['contentBlockBorderRadius'] != '' ? styleData['contentBlockBorderRadius'] + 'px' : 0);
        let contentBlockBackgroundColor = styleData['contentBlockBackgroundColor'] != 'No background' ? styleData['contentBlockBackgroundColor'] : 'transparent';
        let contentBlockPadding = styleData['contentBlockPaddingIndividualSide'] ? (styleData['contentBlockPaddingTop'] + 'px ' + styleData['contentBlockPaddingRight'] + 'px ' + styleData['contentBlockPaddingBottom'] + 'px ' + styleData['contentBlockPaddingLeft'] + 'px') : (styleData['contentBlockPadding'] != '' ? styleData['contentBlockPadding'] + 'px' : 0);
        let contentBlockMargin = styleData['contentBlockMarginIndividualSide'] ? (styleData['contentBlockMarginTop'] + 'px ' + styleData['contentBlockMarginRight'] + 'px ' + styleData['contentBlockMarginBottom'] + 'px ' + styleData['contentBlockMarginLeft'] + 'px') : (styleData['contentBlockMargin'] != '' ? styleData['contentBlockMargin'] + 'px' : 0);

        let tableBorderWidthToBeAppliedForHeader = styleData['tableBorderWidthIndividualSide'] ? (styleData['tableBorderWidthTop'] + 'px ' + styleData['tableBorderWidthRight'] + 'px ' + styleData['titleTextBorderWidth'] + 'px ' + styleData['tableBorderWidthLeft'] + 'px') : (styleData['tableBorderWidth'] != '' ? (styleData['tableBorderWidth'] + 'px ' + styleData['tableBorderWidth'] + 'px ' + styleData['titleTextBorderWidth'] + 'px ' + styleData['tableBorderWidth'] + 'px') : 0);
        let tableBorderWidthToBeAppliedForBody = styleData['tableBorderWidthIndividualSide'] ? (styleData['titleTextBorderWidth'] + 'px ' + styleData['tableBorderWidthRight'] + 'px ' + styleData['tableBorderWidthBottom'] + 'px ' + styleData['tableBorderWidthLeft'] + 'px') : (styleData['tableBorderWidth'] != '' ? (styleData['titleTextBorderWidth'] + 'px ' + styleData['tableBorderWidth'] + 'px ' + styleData['tableBorderWidth'] + 'px ' + styleData['tableBorderWidth'] + 'px') : 0);
        let tableBorderColor = styleData['tableBorderColor'] != 'No colour' ? styleData['tableBorderColor'] : '#ccc';
        let tableBorderVerticalBorderWidth = styleData['tableBorderVerticalBorderWidth'] != '' ? styleData['tableBorderVerticalBorderWidth'] + 'px' : 1;
        let tableBorderVerticalBorderColor = styleData['tableBorderVerticalBorderColor'] != 'No colour' ? styleData['tableBorderVerticalBorderColor'] : '#ccc'

        let titleHeaderFont = styleData['titleHeaderFont'] != '' ? styleData['titleHeaderFont'] : 'Arial';
        let titleHeaderFontWeight = styleData['titleHeaderFontWeight'] != '' ? styleData['titleHeaderFontWeight'] : 400;
        let titleTextSize = styleData['titleTextSize'] != '' ? styleData['titleTextSize'] : 14;
        let titleTextColor = styleData['titleTextColor'] != 'No colour' ? styleData['titleTextColor'] : '#505B65';
        let titleTextAlignment = styleData['titleTextAlignment'] != '' ? styleData['titleTextAlignment'] : 'left';
        let titleTextHeight = styleData['titleTextHeight'] != '' ? styleData['titleTextHeight'] : 27;
        let titleTextBackgroundColor = styleData['titleTextBackgroundColor'] != 'No background' ? styleData['titleTextBackgroundColor'] : 'transparent';
        let titleTextBorderWidth = styleData['titleTextBorderWidthIndividualSide'] ? (styleData['titleTextBorderWidthTop'] + 'px ' + styleData['titleTextBorderWidthRight'] + 'px ' + styleData['titleTextBorderWidthBottom'] + 'px ' + styleData['titleTextBorderWidthLeft'] + 'px') : (styleData['titleTextBorderWidth'] != '' ? styleData['titleTextBorderWidth'] + 'px' : 1);
        let titleTextBorderColor = styleData['titleTextBorderColor'] != 'No colour' ? styleData['titleTextBorderColor'] : '#ccc';

        let rowHeaderFont = styleData['rowHeaderFont'] != '' ? styleData['rowHeaderFont'] : 'Arial';
        let rowHeaderFontWeight = styleData['rowHeaderFontWeight'] != '' ? styleData['rowHeaderFontWeight'] : 400;
        let rowTextSize = styleData['rowTextSize'] != '' ? styleData['rowTextSize'] : 14;
        let rowTextColor = styleData['rowTextColor'] != 'No colour' ? styleData['rowTextColor'] : '#505B65'
        let rowTextAlignment = styleData['rowTextAlignment'] != '' ? styleData['rowTextAlignment'] : 'left'
        let rowTextHeight = styleData['rowTextHeight'] != '' ? styleData['rowTextHeight'] : 27;
        let rowTextBackgroundColor = styleData['rowTextBackgroundColor'] != 'No background' ? styleData['rowTextBackgroundColor'] : 'transparent';
        let rowTextAlternativeBackgroundColor = styleData['rowTextAlternativeBackgroundColor'] != 'No background' ? styleData['rowTextAlternativeBackgroundColor'] : 'transparent';
        let rowTextHorizontalBorderWidth = styleData['rowTextHorizontalBorderWidth'] != '' ? styleData['rowTextHorizontalBorderWidth'] + 'px' : 1;
        let rowTextHorizontalBorderColor = styleData['rowTextHorizontalBorderColor'] != '' ? styleData['rowTextHorizontalBorderColor'] : '#ccc';

        let totalSummaryBorderWidth = styleData['totalSummaryBorderWidthIndividualSide'] ? (styleData['totalSummaryBorderWidthTop'] + 'px ' + styleData['totalSummaryBorderWidthRight'] + 'px ' + styleData['totalSummaryBorderWidthBottom'] + 'px ' + styleData['totalSummaryBorderWidthLeft'] + 'px') : (styleData['totalSummaryBorderWidth'] != '' ? styleData['totalSummaryBorderWidth'] + 'px' : 0);
        let totalSummaryBorderColor = styleData['totalSummaryBorderColor'] != '' ? styleData['totalSummaryBorderColor'] : '#ccc';
        let totalSummaryBackgroundColor = styleData['totalSummaryBackgroundColor'] != 'No background' ? styleData['totalSummaryBackgroundColor'] : 'transparent';
        let totalSummaryPadding = styleData['totalSummaryPadding'] != '' ? styleData['totalSummaryPadding'] + 'px' : 0;
        let totalSummaryMargin = styleData['totalSummaryMargin'] != '' ? styleData['totalSummaryMargin'] + 'px' : 0;
        let totalSummarySubtotalHeaderFont = styleData['totalSummarySubtotalHeaderFont'] != '' ? styleData['totalSummarySubtotalHeaderFont'] : 'Arial'
        let totalSummarySubtotalHeaderFontWeight = styleData['totalSummarySubtotalHeaderFontWeight'] != '' ? styleData['totalSummarySubtotalHeaderFontWeight'] : 400;
        let totalSummarySubtotalTextSize = styleData['totalSummarySubtotalTextSize'] != '' ? styleData['totalSummarySubtotalTextSize'] : 14;
        let totalSummarySubtotalTextColor = styleData['totalSummarySubtotalTextColor'] != 'No colour' ? styleData['totalSummarySubtotalTextColor'] : '#505B65';
        let totalSummarySubtotalLineHeight = styleData['totalSummarySubtotalLineHeight'] != '' ? styleData['totalSummarySubtotalLineHeight'] : 14;
        let totalSummaryGrandTotalHeaderFont = styleData['totalSummaryGrandTotalHeaderFont'] != '' ? styleData['totalSummaryGrandTotalHeaderFont'] : 'Arial';
        let totalSummaryGrandTotalHeaderFontWeight = styleData['totalSummaryGrandTotalHeaderFontWeight'] != '' ? styleData['totalSummaryGrandTotalHeaderFontWeight'] : 400;
        let totalSummaryGrandTotalTextSize = styleData['totalSummaryGrandTotalTextSize'] != '' ? styleData['totalSummaryGrandTotalTextSize'] : 14;
        let totalSummaryGrandTotalTextColor = styleData['totalSummaryGrandTotalTextColor'] != 'No colour' ? styleData['totalSummaryGrandTotalTextColor'] : '#505B65';
        let totalSummaryGrandTotalLineHeight = styleData['totalSummaryGrandTotalLineHeight'] != '' ? styleData['totalSummaryGrandTotalLineHeight'] : 14;
        let financeFontStyle = (styleData['financeFontStyle'] && styleData['financeFontStyle'] != '') ? styleData['financeFontStyle'] : 'Arial';
        let financeFontSize = (styleData['financeFontSize'] && styleData['financeFontSize'] != '') ? styleData['financeFontSize'] : 14;
        let financeTextColor = (styleData['financeTextColor'] && styleData['financeTextColor'] != 'No colour') ? styleData['financeTextColor'] : '#505B65';
        let financeLineHeight = (styleData['financeLineHeight'] && styleData['financeLineHeight'] != '') ? styleData['financeLineHeight'] : 20;
        let grantsFontStyle = (styleData['grantsFontStyle'] && styleData['grantsFontStyle'] != '') ? styleData['grantsFontStyle'] : 'Arial';
        let grantsFontWeight = (styleData['grantsFontWeight'] && styleData['grantsFontWeight'] != '') ? styleData['grantsFontWeight'] : 400;
        let grantsFontSize = (styleData['grantsFontSize'] && styleData['grantsFontSize'] != '') ? styleData['grantsFontSize'] : 14;
        let grantsTextColor = (styleData['grantsTextColor'] && styleData['grantsTextColor'] != 'No colour') ? styleData['grantsTextColor'] : '#505B65';
        let grantsLineHeight = (styleData['grantsLineHeight'] && styleData['grantsLineHeight'] != '') ? styleData['grantsLineHeight'] : 14;


        let dynamicStyle = `${identifier} ${styleData.isNormalTable ? 'div.froala-table' : ''} {
            border-width: ${contentBlockBorderWidth};
            border-style: solid;
            border-color: ${contentBlockBorderColor};
            background: ${contentBlockBackgroundColor};
            padding: ${contentBlockPadding};
            border-radius: ${contentBlockBorderRadius};
            margin: ${contentBlockMargin};
    }

    ${identifier} table thead{
            border-width: ${tableBorderWidthToBeAppliedForHeader};
            border-right-style: solid;
            border-left-style: solid;
            border-top-style: solid;
            border-right-color: ${tableBorderColor};
            border-left-color: ${tableBorderColor};
            border-top-color: ${tableBorderColor};
    }
    ${identifier} table tbody{
            border-width: ${tableBorderWidthToBeAppliedForBody};
            border-right-style: solid;
            border-left-style: solid;
            border-bottom-style: solid;
            border-right-color: ${tableBorderColor};
            border-left-color: ${tableBorderColor};
            border-bottom-color: ${tableBorderColor};
    }
    ${identifier} table thead tr th,
    ${identifier} table tbody tr td {
        border-left-width: ${tableBorderVerticalBorderWidth};
        border-left-style: solid;
        border-left-color: ${tableBorderVerticalBorderColor};
        border-right-width: ${tableBorderVerticalBorderWidth};
        border-right-style: solid;
        border-right-color: ${tableBorderVerticalBorderColor};
    }
    ${identifier} table thead tr{
         border-width: ${titleTextBorderWidth};
         border-style: solid;
         border-color: ${titleTextBorderColor};
    }
    ${identifier} table thead tr th{
            font-family: ${titleHeaderFont};
            font-weight: ${titleHeaderFontWeight} !important;
            font-size: ${titleTextSize}px !important;
            text-align: ${titleTextAlignment};
            height: ${titleTextHeight}px;
            color: ${titleTextColor} !important;
            background-color: ${titleTextBackgroundColor};
    }
    ${identifier} table tbody tr:nth-child(odd) td{
            font-family: ${rowHeaderFont};
            font-weight: ${rowHeaderFontWeight};
            font-size: ${rowTextSize}px !important;
            text-align: ${rowTextAlignment};
            color: ${rowTextColor} !important;
            background-color: ${rowTextBackgroundColor};
        }
         ${identifier} tbody tr:nth-child(even) td{
            font-family: ${rowHeaderFont};
            font-weight: ${rowHeaderFontWeight};
            font-size: ${rowTextSize}px !important;
            text-align: ${rowTextAlignment};
            color: ${rowTextColor} !important;
            background-color: ${rowTextAlternativeBackgroundColor};
        }

        ${identifier} tbody tr td .desc{
            font-family: ${rowHeaderFont};
            font-weight: ${rowHeaderFontWeight};
            font-size: ${rowTextSize}px !important;
            text-align: ${rowTextAlignment};
            color: ${rowTextColor} !important;
            }
            ${identifier} table tr td .notes{
            font-family: ${rowHeaderFont};
            font-weight: ${rowHeaderFontWeight};
            font-size: ${rowTextSize}px !important;
            text-align: ${rowTextAlignment};
            color: ${rowTextColor} !important;
         }
         ${identifier} tbody tr td .pricing-section-part-no-images{
            text-align : ${rowTextAlignment};
            width: 92%;
         }
        ${identifier} table tbody tr.mousehoverNew{
            height: ${rowTextHeight}px;
        }
        ${identifier} table tbody tr {
            border-bottom-width : ${rowTextHorizontalBorderWidth};
            border-bottom-style: solid;
            border-bottom-color: ${rowTextHorizontalBorderColor};
        }
        ${identifier} table tfoot.pricingSection_subGrandTotalBlock{
            border-width: ${totalSummaryBorderWidth};
            border-style: solid;
            border-color: ${totalSummaryBorderColor};
        }
        ${identifier} table tfoot tr{
            background-color: ${totalSummaryBackgroundColor} !important;
        }

        ${identifier} table tfoot tr td div.subtotal-style-apply-here{
            font-family: ${totalSummarySubtotalHeaderFont};
            font-weight: ${totalSummarySubtotalHeaderFontWeight} !important;
            font-size: ${totalSummarySubtotalTextSize}px !important;
            color: ${totalSummarySubtotalTextColor} !important;
            line-height: ${totalSummarySubtotalLineHeight}px !important;
        }
        ${identifier} table tfoot tr td div.grand-total-style-apply-here{
            font-family: ${totalSummaryGrandTotalHeaderFont};
            font-weight: ${totalSummaryGrandTotalHeaderFontWeight} !important;
            font-size: ${totalSummaryGrandTotalTextSize}px !important;
            color: ${totalSummaryGrandTotalTextColor} !important;
            line-height: ${totalSummaryGrandTotalLineHeight}px !important;
        }
        ${identifier} table tfoot tr td.finance-section-new-improvement {
            font-family: ${financeFontStyle};
            font-size: ${financeFontSize}px !important;
            color: ${financeTextColor} !important;
            line-height: ${financeLineHeight}px !important;
        }
        ${identifier} table tfoot tr td div.grants-style-apply-here {
            font-family: ${grantsFontStyle};
            font-weight: ${grantsFontWeight} !important;
            font-size: ${grantsFontSize}px !important;
            color: ${grantsTextColor} !important;
            line-height: ${grantsLineHeight}px !important;
        }
        `

        // //pricing section image alignment css
        // if(rowAlignment == 'left' || rowAlignment == 'justify') {
        //     dynamicStyle += `${identifier} .show-image{
        //     transform: translateX(5px);
        //     }`
        // } else if(rowAlignment == 'center'){
        //     dynamicStyle += `${identifier} .show-image{
        //     transform: translateX(85px);
        //     }`
        // }else if(rowAlignment == 'right') {
        //     dynamicStyle += `${identifier} .show-image{
        //     transform: translateX(173px);
        //     }`
        // }

        if (tableType == 'normalTable') {
            dynamicStyle += `${identifier} div.froala-table{
            border-radius: ${contentBlockBorderRadius};
            overflow: hidden;
        }`
        } else {
            dynamicStyle += `${identifier} {
            border-radius: ${contentBlockBorderRadius};
            overflow: hidden;
        }`
        }

        return dynamicStyle;
    }

    findAndremoveWidth(styleData: any, tableType: any = '') {
        const sectionId = styleData['sectionId'];
        const identifier = tableType === 'pricingSummary'
            ? `#pricing-items-breakup-tpl_${sectionId}`
            : `#Pricing_${sectionId}`;

        const placeEverythingElement: any = $(this.bodyHtmlContent).get(0);
        if (placeEverythingElement) {
            const self:any = $(placeEverythingElement).find('#place_everything');
            if (self && identifier.startsWith('#')) {
                const findTable = self.querySelectorAll(identifier);
                if (findTable && findTable.length) {
                    $(findTable).css({'width': ''});
                }
            }
        }
    }

    updateStylesInCSEditor(dynamicStyle: any, tableType = '') {
        var style: any;
        //TODO: seperate to option summary style and option table style and create dynamic style
        let doc: any = $(this.bodyHtmlContent)
        if (tableType == 'pricingSummary') {
            style = $(this.bodyHtmlContent).find('#dynamic_styling_summary');
        } else if (tableType == 'normalTable') {
            style = $(this.bodyHtmlContent).find('#dynamic_styling_normal');
        } else {
            style = $(this.bodyHtmlContent).find('#dynamic_styling');
        }
        if (style && style.length) {
            return;
        }
        if (!style) {
            style = document.createElement('style');
            if (tableType == 'pricingSummary') {
                style.id = "dynamic_styling_summary";
            } else if (tableType == 'normalTable') {
                style.id = "dynamic_styling_normal";
            } else {
                style.id = "dynamic_styling";
            }
        }
        style.innerHTML = dynamicStyle;
        // Get the first script tag
        let ref: any = document.querySelector('script');
        let placeEverythingElement: any = $(this.bodyHtmlContent).get(0);
        let self = $(placeEverythingElement).find('#place_everything');
        if (self) {
            $(placeEverythingElement).contents().find("head")[0].appendChild(style);
        }
    }

    async youtubeThumbnailRendering(body: any) {
        const child = body.querySelectorAll('.cs_page');
        const promises = [];
        for (const element of child) {
            const extractedData = await this.extractDataFromHTML(element);
            promises.push(this.youtubeAndLoomVideoRendering(extractedData, element));
        }
        await Promise.all(promises);
        this.sendButtonDisabled = true;
        this.sendtoCustomerLoading = false;
        setTimeout(() => {
            this.domRederingImagesElement();
        }, 2000);

        // this.pdfPageLoading = true;
    }

    async extractDataFromHTML(html: any): Promise<any[]> {
        const videoBlocks: any[] = [];
        const csBlocks = html.querySelectorAll('.cs_block_s[tag="video"]');
        csBlocks.forEach((csBlock: any) => {
            const dynamicId = csBlock.getAttribute('id') || '';
            const iframe = csBlock.querySelector('iframe');
            if (iframe == null) {
                return;
            }
            const styleAttr = iframe.getAttribute('style') || '';
            const styles = styleAttr.split(';').reduce((acc: any, style: any) => {
                const [property, value] = style.split(':').map((s: any) => s.trim());
                acc[property] = value;
                return acc;
            }, {});
            const youtubeUrl = iframe.getAttribute('src') || '';
            const youtubeURLorLoomURL = youtubeUrl.includes('youtube') ? 'youtube' : 'loom';
            videoBlocks.push({dynamicId: dynamicId, IframeImageType: youtubeURLorLoomURL, style: styles, youtubeUrl});
        });

        return videoBlocks;
    }

    async youtubeAndLoomVideoRendering(data: any, element: any) {
        for (const blockData of data) {
            if (blockData.IframeImageType === 'youtube') {
                await this.createVideoDivElements(blockData, element, 'youtube');
            } else {
                await this.createVideoDivElements(blockData, element, 'loom');
            }
        }
    }

    domRederingImagesElement() {

        var placeEverythingElement: any = $(this.bodyHtmlContent).get(0);
        if (placeEverythingElement) {
            var findDivElement:any = $(placeEverythingElement).find('#place_everything');;
            let body = findDivElement.querySelectorAll('.cs_page');
            const child = body;
            child.forEach((page: HTMLElement) => {
                const imageElements = page.querySelectorAll('[tag="Image"]');
                const videoElements = page.querySelectorAll('[tag="Video"]');
                const pricingsectionElements = page.querySelectorAll('[tag="pricingsection"]');
                const optionspricingbreakupElements = page.querySelectorAll('[tag="Summary"]');

                imageElements.forEach(elem => {
                    if ($(elem).find('.img-btn').length == 0) {
                        const imgDiv = $(elem).find('img').get(0);
                        const imgWidth = $(imgDiv).css('width');
                        const imgHeight = $(imgDiv).css('height');
                        $(imgDiv).css({'width': imgWidth, 'height': imgHeight})
                    }
                });

                videoElements.forEach(elem => {
                    if ($(elem).find('.img-btn').length == 0) {
                        let videoContainer = $(elem).find('.thumbnail-image').get(0);
                        const width = $(videoContainer).css('width');
                        const height = $(videoContainer).css('height');
                        $(videoContainer).css({'width': width, 'height': height});
                        $(videoContainer).css({'max-width': '', 'max-height': ''});
                    }
                });
                if (pricingsectionElements && pricingsectionElements.length) {
                    this.adjustFinanceSectionHeight(pricingsectionElements);
                }
                if (optionspricingbreakupElements && optionspricingbreakupElements.length) {
                    this.adjustFinanceSectionHeight(optionspricingbreakupElements);
                }
            })

        }

        if(!this.proposalValueMismatch && !this.proposalValueMismatchError){
            this.getCsPageList();
        }
    }

    async createVideoDivElements(data: any, element: any, type: string) {
        const container = $(element).find(`#${data.dynamicId}`);
        const newDiv = document.createElement('div');
        newDiv.classList.add('new-video-block');
        newDiv.style.width = "-webkit-fill-available";
        if (type == 'loom') {
            newDiv.classList.add('loom-video-element-thumbnail');
        }

        const thumbnailImg: any = document.createElement('img');
        thumbnailImg.classList.add('thumbnail-image');
        thumbnailImg.src = type === 'youtube'
            ? `https://img.youtube.com/vi/${data.youtubeUrl.split('/').pop()}/mqdefault.jpg`
            : await this.fetchLoomThumbnail(data.youtubeUrl);

        thumbnailImg.alt = 'Video Thumbnail';

        Object.entries(data.style).forEach(([property, value]) => {
            thumbnailImg.style[property] = value;
        });

        const playButton = document.createElement('div');
        playButton.classList.add(`play-button-${type}`);

        var iconElement = document.createElement("i");

        iconElement.className = "fa fa-play";
        iconElement.classList.add(`play-icon-button-${type}`);
        iconElement.setAttribute("aria-hidden", "true");


        playButton.appendChild(iconElement);
        // playButton.setAttribute('onclick', `showIframe('${data.youtubeUrl+'?autoplay=1'}', '${data.dynamicId}','${type}')`);

        newDiv.appendChild(thumbnailImg);
        newDiv.appendChild(playButton);
        container.append(newDiv);

        const handleSectionSummary = (container: any) => {
            const removeIframe = container.find('iframe');
            removeIframe.remove();
        };

        handleSectionSummary(container);
    }

    adjustFinanceSectionHeight(elements) {
        if (elements && elements.length) {
            for (let i = 0; i < elements.length; i++) {
                let getTableElement = $(elements[i]).find('table');
                if (getTableElement && getTableElement.length) {
                    let getFinanceSection = $(getTableElement).find('.finance-section-new-improvement');
                    if (getFinanceSection && getFinanceSection.length && $(getFinanceSection).attr('breakdown-status') == 'horizontal') {
                        const financeHeight = $(getFinanceSection).height();
                        const parentElement = getFinanceSection.parent();
                        if (parentElement && parentElement.length) {
                            let firstTD = $(parentElement).find('.total-section-right-text-label').parent();
                            let secondTD = $(parentElement).find('.total-section-right-text-value').parent();
                            if (firstTD && firstTD.length && secondTD && secondTD.length) {
                                $(firstTD).css('height', financeHeight);
                                $(secondTD).css('height', financeHeight);
                            }
                        }
                    }
                }
            }
        }
    }

    async fetchLoomThumbnail(videoUrl: string): Promise<string> {
        try {
            const apiUrl = `https://www.loom.com/v1/oembed?url=https://www.loom.com/share/${videoUrl.split('/').pop()}`;
            const response = await fetch(apiUrl);
            if (!response.ok) {
                throw new Error(`Error fetching Loom oEmbed data. Status: ${response.status}`);
            }
            const data = await response.json();
            return data.thumbnail_url;
        } catch (error) {
            console.error('Error:', error.message);
            throw error;
        }
    }

    getCsPageList() {
        var placeEverythingElement: any = $(this.bodyHtmlContent).get(0);
        if (placeEverythingElement) {
            this.pagesDataList = $(placeEverythingElement).find('.cs_page');
            let userConfigDetails = this.authService;
            this.pdfDatamake['countryName'] = userConfigDetails['settings']['_csCountryCode']['languageCode'] == 'en' ? 'unitedkingdom' : 'unitedstates';;
            this.pdfDatamake['opportunitiesProposalID'] = this.opportunityProposalId;
            this.pdfDatamake.htmldata = [];
            for (let i = 0; i < this.pagesDataList.length; i++) {
                this.pdfDatamake.htmldata.push(this.pagesDataList[i].outerHTML);
            }
            this.htmltoPdfConversation();
        }
    }

    callOpportunitiesPages(opportunityId,proposalId,body){
        this.opportunitiesPages(opportunityId,proposalId,body)
    }

    htmltoPdfConversation() {
        this.opportunityService.generatePdfFiles(this.opportunityId, this.pdfDatamake).subscribe(responseData => {
            if (responseData && responseData.hasOwnProperty('pdfFilePath')) {
                let data = {
                    'type': 'email',
                    'fileName': `PROPOSAL_${this.opportunityId}_${this.opportunityProposalId}_1.pdf`,
                    //PROPOSAL_3187_2844_1.pdf
                    'pdfData': {
                        'id': 'ProposalPDF',
                        'name': `PROPOSAL_${this.opportunityId}_${this.opportunityProposalId}_1.pdf`,
                        'location': '',
                        'size': 500,
                        'filetype': 'pdf',
                        'opportunityId': this.opportunityId,
                        'selected': false,
                        'attached': false
                    },
                }
                this.setPdfData(data);
                this.sendButtonDisabled = false;
                this.sendtoCustomerLoading = false;
            }
        });
    }

    private defectDetails = new BehaviorSubject<any>(null);
    defectDetails$ = this.defectDetails.asObservable();

    setPdfData(data: any) {
        this.defectDetails.next(data);
    }


}
